import type { MarketVariants } from '@/lib/i18n'

export type Slide05Copy = {
  title: string
  /** Body sentence. Must contain the sentinel "{emphasis}" exactly once. The
   *  chunk replaced by it is rendered in a darker, bolder style and contains
   *  the animated percentage number followed by `emphasisSuffix`. */
  body: string
  /** Text rendered immediately after the animated percentage number. Begins
   *  with the unit glyph (e.g. "%") so it sits snug against the digit. */
  emphasisSuffix: string
  /** Screen-reader label for the dot grid. Must contain "{filled}" and
   *  "{total}" exactly once each. */
  dotsAriaLabel: string
}

export const copy: MarketVariants<Slide05Copy> = {
  US: {
    title: "You've probably\nseen it yourself.",
    body: 'In the last year alone, {emphasis} worldwide experienced a scam.',
    emphasisSuffix: '% of adults',
    dotsAriaLabel: '{filled} out of {total} experienced a scam',
  },
  ar: {
    title: 'على الأرجح\nرأيت ذلك بنفسك.',
    body: 'في العام الماضي وحده، تعرّض {emphasis} حول العالم لمحاولة احتيال.',
    emphasisSuffix: '% من البالغين',
    dotsAriaLabel: '{filled} من أصل {total} تعرّضوا لمحاولة احتيال',
  },
}
